import React from 'react';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import AlertConfigurationTable from '../../Fields/AlertConfigurationTable';


class SettingsAlertsPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      settings,
      fieldConfiguration,
      editMode
    } = this.props;

    const {
      alertConfiguration: alertConfigurationFieldConfiguration
    } = fieldConfiguration;

    return (
      <div>
        <FieldGroup label="Alert Recipients">
          <Field layout="stacked">
            <AlertConfigurationTable inputId="parkchirp--settings--alert-configurations"
              alertConfigurations={settings.fields.alert_configurations.value}
              fieldConfiguration={alertConfigurationFieldConfiguration}
              editMode={editMode}
              onAlertConfigurationChange={this._onInputChange('alert_configurations')}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default SettingsAlertsPanel;
